// extracted by mini-css-extract-plugin
export var list = "index-module--list--Px2GB";
export var listItem = "index-module--list-item--Xs4my";